/**
 * Partner Assignments Constants
 * Labels, translations, and configuration
 */

import { ExpertType, AssignmentStatus } from '@/types/partner-assignments.types';

export const EXPERT_TYPE_LABELS: Record<ExpertType, { en: string; fr: string }> = {
  cpa: { en: 'CPA / Accountant', fr: 'CPA / Comptable' },
  lawyer: { en: 'Business Lawyer', fr: 'Avocat d\'affaires' },
  notary: { en: 'Notary', fr: 'Notaire' },
  tax_advisor: { en: 'Tax Advisor', fr: 'Conseiller fiscal' },
  immigration: { en: 'Immigration Lawyer', fr: 'Avocat en immigration' },
  business_law: { en: 'Corporate Lawyer', fr: 'Avocat corporatif' },
};

export const ASSIGNMENT_STATUS_LABELS: Record<AssignmentStatus, { en: string; fr: string }> = {
  pending: { en: 'Pending', fr: 'En attente' },
  accepted: { en: 'Accepted', fr: 'Accepté' },
  in_progress: { en: 'In Progress', fr: 'En cours' },
  completed: { en: 'Completed', fr: 'Terminé' },
  cancelled: { en: 'Cancelled', fr: 'Annulé' },
};

export const PARTNER_TRANSLATIONS = {
  en: {
    title: 'Expert Assignments',
    subtitle: 'Connect with internal experts for your transaction',
    assignExpert: 'Assign Expert',
    selectExpert: 'Select Expert',
    selectExpertType: 'Expert Type',
    assignmentDetails: 'Assignment Details',
    description: 'Description',
    myAssignments: 'My Assignments',
    activeAssignments: 'Active Assignments',
    completedAssignments: 'Completed Assignments',
    noAssignments: 'No assignments yet',
    accept: 'Accept',
    decline: 'Decline',
    markComplete: 'Mark Complete',
    viewDetails: 'View Details',
    sendMessage: 'Send Message',
    expertInfo: 'Expert Information',
    clientInfo: 'Client Information',
    dealInfo: 'Deal Information',
    status: 'Status',
    createdAt: 'Created',
    assignedBy: 'Assigned By',
    notes: 'Notes',
    addNote: 'Add Note',
    assignmentCreated: 'Expert assigned successfully',
    assignmentAccepted: 'Assignment accepted',
    assignmentCompleted: 'Assignment marked as complete',
    assignmentCancelled: 'Assignment cancelled',
    openChat: 'Open Chat',
    scheduleCall: 'Schedule Call',
    uploadDocument: 'Upload Document',
    available: 'Available',
    busy: 'Busy',
    unavailable: 'Unavailable',
    rating: 'Rating',
    completedDeals: 'Completed Deals',
    specializations: 'Specializations',
    languages: 'Languages',
    contact: 'Contact',
  },
  fr: {
    title: 'Affectations d\'experts',
    subtitle: 'Connectez-vous avec des experts internes pour votre transaction',
    assignExpert: 'Affecter un expert',
    selectExpert: 'Sélectionner un expert',
    selectExpertType: 'Type d\'expert',
    assignmentDetails: 'Détails de l\'affectation',
    description: 'Description',
    myAssignments: 'Mes affectations',
    activeAssignments: 'Affectations actives',
    completedAssignments: 'Affectations terminées',
    noAssignments: 'Aucune affectation pour le moment',
    accept: 'Accepter',
    decline: 'Refuser',
    markComplete: 'Marquer comme terminé',
    viewDetails: 'Voir les détails',
    sendMessage: 'Envoyer un message',
    expertInfo: 'Informations sur l\'expert',
    clientInfo: 'Informations sur le client',
    dealInfo: 'Informations sur le deal',
    status: 'Statut',
    createdAt: 'Créé le',
    assignedBy: 'Assigné par',
    notes: 'Notes',
    addNote: 'Ajouter une note',
    assignmentCreated: 'Expert assigné avec succès',
    assignmentAccepted: 'Affectation acceptée',
    assignmentCompleted: 'Affectation marquée comme terminée',
    assignmentCancelled: 'Affectation annulée',
    openChat: 'Ouvrir le chat',
    scheduleCall: 'Planifier un appel',
    uploadDocument: 'Téléverser un document',
    available: 'Disponible',
    busy: 'Occupé',
    unavailable: 'Non disponible',
    rating: 'Évaluation',
    completedDeals: 'Dossiers complétés',
    specializations: 'Spécialisations',
    languages: 'Langues',
    contact: 'Contact',
  },
};
